export default __webpack_public_path__ + "460d85c316f6275d2ae50d1e988b852a.png";